"use client";

import { Locales } from "intlayer";
import { useLocale } from "next-intlayer";

export default function LocaleSwitcher() {
  const { locale, setLocale } = useLocale();

  return (
    <div className="flex items-center gap-1 text-sm font-medium">
      <button
        type="button"
        onClick={() => setLocale(Locales.ENGLISH)}
        className={`px-2 py-1 rounded transition-colors ${
          locale === Locales.ENGLISH
            ? "text-[#0193cd] font-semibold"
            : "text-muted-foreground hover:text-foreground"
        }`}
        aria-label="Switch to English"
      >
        EN
      </button>
      <span className="text-muted-foreground/50">|</span>
      <button
        type="button"
        onClick={() => setLocale(Locales.THAI)}
        className={`px-2 py-1 rounded transition-colors ${
          locale === Locales.THAI
            ? "text-[#0193cd] font-semibold"
            : "text-muted-foreground hover:text-foreground"
        }`}
        aria-label="เปลี่ยนเป็นภาษาไทย"
      >
        TH
      </button>
    </div>
  );
}
